export const url = "https://hq-capitalnest.com/hqcapitalnest/api";


// export const url ="http://localhost:5000/emerald/api";